export const APP_MOUNTED = "APP_MOUNTED";

export function appMounted(payload){
    return {
        type: APP_MOUNTED,
        payload: payload
    };
}